import { render, staticRenderFns } from "./App.vue?vue&type=template&id=84c918ca&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=84c918ca&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=84c918ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c918ca",
  null
  
)

export default component.exports